import { FC } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

/**
 * A table column header tail.
 */
export const TableColumnHeaderTail: FC = () => {
  return (
    <th className={classNames(styles.TableColumnHeader, "column-header", "tail")} scope="col">
      <div className="cell-outer-content"><div className="cell-inner-content" /></div>
    </th>
  );
};
